import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ENV } from "@app/env";
import { AngularFireDatabase } from "angularfire2/database";
import { AuthData } from "./auth";
import { Utilities } from "./utilities";
import { take } from "rxjs/operators";

@Injectable()
export class NetworkingService {

  constructor(
    private afdb: AngularFireDatabase,
    private utilities: Utilities,
    private http: HttpClient,
    private authService: AuthData,
  ) { }

  public getConfig(clientId: string, eventId: string = null) {
    let ref = `Clients/${clientId}/Interactivity/NetworkingConfig`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/NetworkingConfig`;
    }
    return this.afdb.object<any>(ref).valueChanges();
  }

  public setNetworkingConfig(clientId: string, eventId: string, info: any) {
    let ref = `Clients/${clientId}/Interactivity/NetworkingConfig`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/NetworkingConfig`;
    }

    return new Promise((res, rej) => {
      this.afdb.database
        .ref(ref)
        .set(info)
        .then(() => {
          return res(true);
        })
        .catch((e) => {
          return rej(e);
        });
    });
  }

  public async getNetworkingRequests(cid: string, eid = "--") {
    const token = await this.authService.getTokenUser().pipe(take(1)).toPromise();
    const headers = new HttpHeaders({ Authorization: token });
    return this.http.get<any>(`${ENV.backend}/networking?client=${cid}&eventId=${eid}`, { headers }).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/providers/networking.service.ts